/**
 * Aplica atualização do front no desktop: ativa SW novo, limpa Cache Storage e recarrega.
 * Equivalente prático a “pegar a versão nova” sem depender só do evento `controlling`.
 */
export async function applyDesktopAppUpdate(
  updateServiceWorker: (reloadPage?: boolean) => Promise<void>,
  options?: {
    clearCaches?: boolean
    reload?: () => void
    cachesApi?: Pick<CacheStorage, 'keys' | 'delete'>
  },
): Promise<void> {
  const clearCaches = options?.clearCaches !== false
  const reload = options?.reload ?? (() => window.location.reload())
  const cachesApi = options?.cachesApi

  try {
    await updateServiceWorker(true)
  } catch {
    // Continua com limpeza + reload mesmo se o SW falhar.
  }

  if (clearCaches) {
    try {
      const api = cachesApi ?? (typeof caches !== 'undefined' ? caches : undefined)
      if (api) {
        const keys = await api.keys()
        await Promise.all(keys.map((key) => api.delete(key)))
      }
    } catch {
      // Ignora falha de Cache Storage — o reload ainda busca assets novos.
    }
  }

  reload()
}
